import { get, set } from "firebase/database";
import { ref, push, databaseStats } from "../firebase";

export const isMobileUserAgent = () => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod|android/.test(userAgent);
};

export const getCurrentDateTimeFormatted = () => {
    const now = new Date();
    const day = now.getDate();
    const monthNames = [
        "января",
        "февраля",
        "марта",
        "апреля",
        "мая",
        "июня",
        "июля",
        "августа",
        "сентября",
        "октября",
        "ноября",
        "декабря",
    ];
    const month = monthNames[now.getMonth()];
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");

    return `Дата: ${day} ${month} ${year}; Время ${hours}:${minutes}`;
};

export const pushStats = async (pageName) => {
    try {
        const statisticRef = ref(databaseStats, "/statsDetails");
        await push(statisticRef, {
            dateTime: getCurrentDateTimeFormatted(),
            page: pageName,
        });
    } catch (error) {
        console.error("Error pushing data:", error);
    }
};

export const pushStatsAmount = async (pageName, amount) => {
    try {
        const statisticRef = ref(databaseStats, `/stats/${pageName}`);
        await set(statisticRef, amount);
    } catch (error) {
        console.error("Error pushing data:", error);
    }
};

export const checkAndSetStats = async (pageName) => {
    const dbRefHistory = ref(databaseStats, `/stats/${pageName}`);

    get(dbRefHistory)
        .then((snapshot) => {
            if (snapshot.exists()) {
                const newValue = (snapshot.val() || 0) + 1;
                pushStatsAmount(pageName, newValue);
            } else {
                console.log("No data available");
            }
        })
        .catch((error) => {
            console.error(error);
        });
};

export const formatPrice = (number) => {
    if (!number) return "-";
    if (number > 999) {
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " грн";
    } else {
        return number.toString() + " грн";
    }
};

export const capitalize = (str) => {
    const string = `${str}`;
    if (!string) return string;
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const scrollToElement = (elemId) => {
    const element = document.getElementById(elemId);

    if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
        console.error(`Элемент ${elemId} не найден.`);
    }
};

export const formatShortDate = (d, l = "ru-RU") =>
    d instanceof Date && !isNaN(d)
        ? `${d.toLocaleDateString(l, {
              year: "numeric",
              month: "long",
              day: "numeric",
          })} в ${d.toLocaleTimeString(l, {
              hour: "2-digit",
              minute: "2-digit",
          })}`
        : "Некорректная дата";

// Encode article for URL (replace "/" with URL-safe encoding)
export const encodeArticleForUrl = (article) => {
    if (!article) return article;
    return String(article).replace(/\//g, "%2F");
};

// Decode article from URL (replace "%2F" back to "/")
export const decodeArticleFromUrl = (urlArticle) => {
    if (!urlArticle) return urlArticle;
    return String(urlArticle).replace(/%2F/gi, "/");
};

export const getMenuItems = (navigate, callback = () => null) => [
    {
        label: "Сторінки",
        items: [
            {
                label: "Домашня сторінка",
                icon: "pi pi-home",
                command: () => {
                    navigate("/");
                    callback();
                },
            },
            {
                label: "Каталог",
                icon: "pi pi-table",
                command: () => {
                    navigate("/catalog");
                    callback();
                },
            },
        ],
    },
    {
        label: "Колекції",
        items: [
            {
                label: "Diamonds",
                icon: "pi pi-heart",
                command: () => {
                    navigate("/diamonds");
                    callback();
                },
            },
            {
                label: "Billion",
                icon: "pi pi-thumbs-up",
                command: () => {
                    navigate("/billion");
                    callback();
                },
            },
            {
                label: "Kolorovi",
                icon: "pi pi-palette",
                command: () => {
                    navigate("/kolorovi");
                    callback();
                },
            },
            {
                label: "AirGold",
                icon: "pi pi-sun",
                command: () => {
                    navigate("/air-gold");
                    callback();
                },
            },
            {
                label: "Vidrodzhennya",
                icon: "pi pi-plus",
                command: () => {
                    navigate("/vidrodzhennya");
                    callback();
                },
            },
            {
                label: "Harmony",
                icon: "pi pi-moon",
                command: () => {
                    navigate("/harmony");
                    callback();
                },
            },
            {
                label: "Reflect",
                icon: "pi pi-th-large",
                command: () => {
                    navigate("/reflect");
                    callback();
                },
            },
        ],
    },
    {
        label: "Інше",
        items: [
            {
                label: "Обмін",
                icon: "pi pi-sort-alt",
                command: () => {
                    navigate("/exchange");
                    callback();
                },
            },
        ],
    },
];
